import React from 'react'

import { useNumericParams } from '@domain-group/react-hooks'

import useReduxAction from '@hooks/useReduxAction'

import defaultRequestOptions from '@sections/Admin/packs/SystemManager/defaultRequestOptions'
import ProductEditRoutes from './routes'

const ProductEdit = () => {
  const { serviceProductId } = useNumericParams()

  useReduxAction(
    'serviceProducts',
    'loadServiceProduct',
    {
      entityId: serviceProductId,
      ...defaultRequestOptions.serviceProduct,
    },
    [serviceProductId],
    {
      dispatchAction: (action, requestOptions) => action(serviceProductId, requestOptions),
      shouldPerformFn: ({ loading }) => serviceProductId && !loading,
    },
  )

  return (
    <ProductEditRoutes serviceProductId={serviceProductId} />
  )
}

export default ProductEdit
